export type SocialKey = 'tiktokUrl' | 'xUrl' | 'facebookUrl' | 'instagramUrl' | 'websiteUrl'

export interface SocialLink {
  key: SocialKey
  label: string
  placeholder: string
}

export const SOCIAL_FIELDS: SocialLink[] = [
  { key: 'tiktokUrl', label: 'TikTok', placeholder: 'https://www.tiktok.com/@yourshop' },
  { key: 'xUrl', label: 'X', placeholder: 'https://x.com/yourshop' },
  { key: 'facebookUrl', label: 'Facebook', placeholder: 'https://www.facebook.com/yourshop' },
  { key: 'instagramUrl', label: 'Instagram', placeholder: 'https://www.instagram.com/yourshop' },
  { key: 'websiteUrl', label: 'Website', placeholder: 'https://yourshop.com' },
]

export function withHttps(url?: string) {
  const value = url?.trim() || ''
  if (!value) return ''
  if (/^https?:\/\//i.test(value)) return value
  return `https://${value}`
}
